<template>
  <div id="app" ref="vueApp" style="display: none">
    <v-main></v-main>
  </div>
</template>


<script>
import Main from '@/views/Main.vue'
export default {
  name: 'App',
  components: {
    'v-main': Main
  },
  mounted() {
    this.$refs.vueApp.style.display = 'block';
  }
}
</script>

<style lang="scss">
body{
  font-family: Roboto;
}
#app {
  //font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
  /*margin-top: 60px;*/
  min-width: 1000px;
}
@media screen and (max-width: 800px) {
  #app {
    min-width: unset;
    video{
      //display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue